import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

let state =  require('../store/index').default.state
import _this from '../main.js'

let newApj = 'http://47.105.233.230:8282'// 测试环境
// let newApj = 'https://api-test.sheepboss.com'// 正式

class BaseModule {
  userSmsSend (data) {//获取验证码
		return this.postFn(newApj + '/api/user/sms/send', data)
  }
  userLogin (data) {//用户登录
		return this.postFn(newApj + '/api/user/login', data)
  }
  userRegister (data) {//用户注册
		return this.postFn(newApj + '/api/user/register', data)
  }
  userProfile (data) {//基本信息
		return this.getFn(newApj + '/api/user/profile', data)
  }
  userPasswordEdit (data) {//修改密码
		return this.postFn(newApj + '/api/user/password/edit', data)
  }
  userLogout (data) {//登出
		return this.postFn(newApj + '/api/user/logout', data)
  }
  userForgotPassword (data) {//忘记密码
		return this.postFn(newApj + '/api/user/forgot/password', data)
  }
  userQrcodeGetcode (data) {//获取登录二维码
		return this.getFn(newApj + '/api/user/qrcode/getcode', data)
  }
  userQrcodeStatus (data) {//二维码状态
		return this.postFn(newApj + '/api/user/qrcode/status', data)
  }
  userCompanyLinkListAvailable (data) {//可查看的主体
		return this.getFn(newApj + '/api/user/company/link/list/available', data)
  }
  userChangeCompany (data) {//切换主体
		return this.postFn(newApj + '/api/user/change/company', data)
  }
  userStatisticsPie (data) {//饼图
		return this.getFn(newApj + '/api/user/statistics/pie', data)
  }
  userStatisticsLine (data) {//折线图
		return this.getFn(newApj + '/api/user/statistics/line', data)
  }
  userCompanyInfoSave (data) {//完善企业信息
		return this.postFn(newApj + '/api/user/company/info/save', data)
  }
  userCompanyInfo (data) {//获取企业信息
		return this.getFn(newApj + '/api/user/company/info', data)
  }
  userCompanyInfoEdit (data) {//修改企业信息
		return this.postFn(newApj + '/api/user/company/info/edit', data)
  }
  areaProvinceList (data) {//行政区划省
		return this.getFn(newApj + '/api/area/province/list', data)
  }
  areaCityList (data) {//行政区划市
		return this.getFn(newApj + '/api/area/city/list', data)
  }
  areaCountyList (data) {//行政区划县区
		return this.getFn(newApj + '/api/area/county/list', data)
  }
  areaTownList (data) {//行政区划乡镇
		return this.getFn(newApj + '/api/area/town/list', data)
  }
  photoUpload (data) {//图片上传
		return this.uploadFn(newApj + '/api/photo/upload', data)
  }
  userSheepImport (data) {//批量导入
		return this.uploadFn(newApj + '/api/user/sheep/import', data)
  }
  userFarmListAvailable (data) {//场设置下拉列表
		return this.getFn(newApj + '/api/user/farm/list/available', data)
  }
  userFarmEarTagPrefix (data) {//耳标前缀
		return this.getFn(newApj + '/api/user/farm/ear/tag/prefix', data)
  }
  userFarmList (data) {//场设置列表查询
		return this.getFn(newApj + '/api/user/farm/list', data)
  }
  userFarmSave (data) {//场设置新增修改
		return this.postFn(newApj + '/api/user/farm/save', data)
  }
  userFarmDelete (data) {//场设置删除
		return this.postFn(newApj + '/api/user/farm/delete', data)
  }
  userPartitionListAvailable (data) {//区设置下拉列表
		return this.getFn(newApj + '/api/user/partition/list/available', data)
  }
  userPartitionList (data) {//区设置列表查询
		return this.getFn(newApj + '/api/user/partition/list', data)
  }
  userPartitionSave (data) {//区设置新增修改
		return this.postFn(newApj + '/api/user/partition/save', data)
  }
  userPartitionDelete (data) {//区设置删除
		return this.postFn(newApj + '/api/user/partition/delete', data)
  }
  userGroupListAvailable (data) {//群设置下拉列表
		return this.getFn(newApj + '/api/user/group/list/available', data)
  }
  userGroupListAvailable (data) {//群设置列表查询
		return this.getFn(newApj + '/api/user/group/list/available', data)
  }
  userGroupDetail (data) {//群设置已选择群
		return this.getFn(newApj + '/api/user/group/detail', data)
  }
  userGroupSave (data) {//群设置勾选群
		return this.postFn(newApj + '/api/user/group/save', data)
  }
  userHouseListAvailable (data) {//舍设置下拉列表
		return this.getFn(newApj + '/api/user/house/list/available', data)
  }
  userHouseList (data) {//舍设置列表查询
		return this.getFn(newApj + '/api/user/house/list', data)
  }
  userHouseSave (data) {//舍设置新增修改
		return this.postFn(newApj + '/api/user/house/save', data)
  }
  userHouseDelete (data) {//舍设置删除
		return this.postFn(newApj + '/api/user/house/delete', data)
  }
  userHouseQrcode (data) {//舍二维码
		return this.getFn(newApj + '/api/user/house/qrcode', data)
  }
  userCompanyLinkListDown (data) {//关联组织列表子公司
		return this.getFn(newApj + '/api/user/company/link/list/down', data)
  }
  userCompanyLinkListUp (data) {//关联组织列表上级组织
		return this.getFn(newApj + '/api/user/company/link/list/up', data)
  }
  userCompanyLinkSave (data) {//关联组织新增修改
		return this.postFn(newApj + '/api/user/company/link/save', data)
  }
  userCompanyLinkDelete (data) {//关联组织删除
		return this.postFn(newApj + '/api/user/company/link/delete', data)
  }
  userCompanyLinkAccept (data) {//关联组织同意关联
		return this.postFn(newApj + '/api/user/company/link/accept', data)
  }
  userCompanyLinkCancel (data) {//关联组织取消关联
		return this.postFn(newApj + '/api/user/company/link/cancel', data)
  }
  userDeptTree (data) {//部门管理部门树
		return this.getFn(newApj + '/api/user/dept/tree', data)
  }
  userDeptSave (data) {//部门管理新增修改
		return this.postFn(newApj + '/api/user/dept/save', data)
  }
  userDeptDelete (data) {//部门管理删除
		return this.postFn(newApj + '/api/user/dept/delete', data)
  }
  userUserListAvailable (data) {//用户管理下拉列表
		return this.getFn(newApj + '/api/user/user/list/available', data)
  }
  userUserList (data) {//用户管理列表查询
		return this.getFn(newApj + '/api/user/user/list', data)
  }
  userUserSave (data) {//用户管理新增修改
		return this.postFn(newApj + '/api/user/user/save', data)
  }
  userUserDelete (data) {//用户管理删除
		return this.postFn(newApj + '/api/user/user/delete', data)
  }
  userRoleListAvailable (data) {//角色管理下拉列表
		return this.getFn(newApj + '/api/user/role/list/available', data)
  }
  userRoleList (data) {//角色管理列表查询
		return this.getFn(newApj + '/api/user/role/list', data)
  }
  userRoleSave (data) {//角色管理新增修改
		return this.postFn(newApj + '/api/user/role/save', data)
  }
  userRoleDelete (data) {//角色管理删除
		return this.postFn(newApj + '/api/user/role/delete', data)
  }
  userRolePermission (data) {//角色管理权限设置
		return this.postFn(newApj + '/api/user/role/permission', data)
  }
  userDictTypeList (data) {//数据字典字典类别
		return this.getFn(newApj + '/api/user/dict/type/list', data)
  }
  userDictList (data) {//数据字典字典列表
		return this.getFn(newApj + '/api/user/dict/list', data)
  }
  userDictSave (data) {//数据字典新增修改
		return this.postFn(newApj + '/api/user/dict/save', data)
  }
  userDictDelete (data) {//数据字典删除
		return this.postFn(newApj + '/api/user/dict/delete', data)
  }
  companyListKeyword (data) {//下拉列表
		return this.getFn(newApj + '/api/company/list/keyword', data)
  }
  userPenListAvailable (data) {//圈管理下拉列表
		return this.getFn(newApj + '/api/user/pen/list/available', data)
  }
  userPenList (data) {//圈管理列表查询
		return this.getFn(newApj + '/api/user/pen/list', data)
  }
  userPenSet (data) {//圈管理圈设置
		return this.postFn(newApj + '/api/user/pen/set', data)
  }
  userSheepListByPen (data) {//圈管理圈羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/pen', data)
  }
  userSheepDelete (data) {//圈管理删除羊
		return this.postFn(newApj + '/api/user/sheep/delete', data)
  }
  userManagFarmSumList (data) {//养殖管理场列表
		return this.getFn(newApj + '/api/user/manage/farm/sum/list', data)
  }
  userManagFarmHouseList (data) {//养殖管理舍列表
		return this.getFn(newApj + '/api/user/manage/farm/house/list', data)
  }
  userManagFarmDeliverySum (data) {//养殖管理羔羊/待产/保育羊数量统计
		return this.getFn(newApj + '/api/user/manage/farm/delivery/sum', data)
  }
  userSheepListByHouse (data) {//养殖管理羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/house', data)
  }
  userManageHousePenList (data) {//养殖管理圈列表
		return this.getFn(newApj + '/api/user/manage/house/pen/list', data)
  }
  userSheepArchives (data) {//羊档案
		return this.getFn(newApj + '/api/user/sheep/archives', data)
  }
  userSheepSave (data) {//新增修改羊
		return this.postFn(newApj + '/api/user/sheep/save', data)
  }
  userSheepListByCode (data) {//通过code查询羊
		return this.getFn(newApj + '/api/user/sheep/list/by/code', data)
  }
  userSheepListByEarTagCode (data) {//通过耳标查询羊
		return this.getFn(newApj + '/api/user/sheep/list/by/earTagCode', data)
  }
  userEarTagEdit (data) {//更换|佩戴耳标
		return this.postFn(newApj + '/api/user/ear/tag/edit', data)
  }
  userEarTagListForSheep (data) {//更换|佩戴耳标记录
		return this.getFn(newApj + '/api/user/ear/tag/list/for/sheep', data)
  }
  userSheepListByPen (data) {//圈-羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/pen', data)
  }
  userManageHouseSum (data) {//舍统计
		return this.getFn(newApj + '/api/user/manage/house/sum', data)
  }
  userGroupChangePenList (data) {//群调整历史记录列表
		return this.getFn(newApj + '/api/user/group/change/pen/list', data)
  }
  userGroupChangePenSave (data) {//群调整新增
		return this.postFn(newApj + '/api/user/group/change/pen/save', data)
  }
  userGroupChangeList (data) {//转群列表查询
		return this.getFn(newApj + '/api/user/group/change/list', data)
  }
  userGroupChangeSave (data) {//转群新增修改
		return this.postFn(newApj + '/api/user/group/change/save', data)
  }
  userSaleList (data) {//销售列表查询
		return this.getFn(newApj + '/api/user/sale/list', data)
  }
  userSaleSave (data) {//销售新增修改
		return this.postFn(newApj + '/api/user/sale/save', data)
  }
  userDeathList (data) {//死亡列表查询
		return this.getFn(newApj + '/api/user/death/list', data)
  }
  userDeathSave (data) {//死亡新增修改
		return this.postFn(newApj + '/api/user/death/save', data)
  }
  userMatingList (data) {//配种列表查询
		return this.getFn(newApj + '/api/user/mating/list', data)
  }
  userMatingSave (data) {//配种新增修改
		return this.postFn(newApj + '/api/user/mating/save', data)
  }
  userSpermListAvailable (data) {//可用的精液列表
		return this.getFn(newApj + '/api/user/sperm/list/available', data)
  }
  userSelectCompany (data) {//选择主体
		return this.postFn(newApj + '/api/user/select/company', data)
  }
  userPsiCategoryTreeAvailable (data) {//商品分类(可用树结构(下拉选择使用))
		return this.getFn(newApj + '/api/user/psi/category/tree/available', data)
  }
  userPsiCategoryTreeSecondAvailable (data) {//商品分类(获取二级分类(下拉选择使用))
		return this.getFn(newApj + '/api/user/psi/category/tree/second/available', data)
  }
  userPsiCategoryTree (data) {//商品分类(树结构)
		return this.getFn(newApj + '/api/user/psi/category/tree', data)
  }
  userPsiCategoryFirstSave (data) {//商品分类(一级新增修改)
		return this.postFn(newApj + '/api/user/psi/category/first/save', data)
  }
  userPsiCategorySecondSave (data) {//商品分类(二级新增修改)
		return this.postFn(newApj + '/api/user/psi/category/second/save', data)
  }
  userPsiCategoryDelete (data) {//商品分类(删除)
		return this.postFn(newApj + '/api/user/psi/category/delete', data)
  }
  userPsiGoodsList (data) {//商品管理(列表)
		return this.getFn(newApj + '/api/user/psi/goods/list', data)
  }
  userPsiGoodsSave (data) {//商品管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/goods/save', data)
  }
  userPsiGoodsDelete (data) {//商品管理(删除)
		return this.postFn(newApj + '/api/user/psi/goods/delete', data)
  }
  userPsiGoodsSupplyCycleList (data) {//商品管理(供货周期-列表)
		return this.getFn(newApj + '/api/user/psi/goods/supply/cycle/list', data)
  }
  userPsiGoodsSupplyCycleSave(data) {//商品管理(供货周期-新增修改)
		return this.postFn(newApj + '/api/user/psi/goods/supply/cycle/save', data)
  }
  userPsiGoodsSupplyCycleDelete(data) {//商品管理(供货周期-删除)
		return this.postFn(newApj + '/api/user/psi/goods/supply/cycle/delete', data)
  }
  userPsiSupplierListAvailable(data) {//供应商管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/supplier/list/available', data)
  }
  userPsiSupplierList(data) {//供应商管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/supplier/list', data)
  }
  userPsiSupplierSave(data) {//供应商管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/supplier/save', data)
  }
  userPsiSupplierDelete(data) {//供应商管理(删除)
		return this.postFn(newApj + '/api/user/psi/supplier/delete', data)
  }
  userPsiCustomListAvailable(data) {//客户管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/custom/list/available', data)
  }
  userPsiCustomList(data) {//客户管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/custom/list', data)
  }
  userPsiCustomSave(data) {//客户管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/custom/save', data)
  }
  userPsiCustomDelete(data) {//客户管理(删除)
		return this.postFn(newApj + '/api/user/psi/custom/delete', data)
  }
  userPsiHouseListAvailable(data) {//库房管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/house/list/available', data)
  }
  userPsiHouseList(data) {//库房管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/list', data)
  }
  userPsiHouseSave(data) {//库房管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/save', data)
  }
  userPsiHouseDelete(data) {//库房管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/delete', data)
  }
  userPsiStockReport1(data) {//统计报表(采购统计)
		return this.getFn(newApj + '/api/user/psi/stock/report1', data)
  }
  userPsiStockReport2(data) {//统计报表(销售统计)
		return this.getFn(newApj + '/api/user/psi/stock/report2', data)
  }
  userPsiStockReport3(data) {//统计报表(入库明细)
		return this.getFn(newApj + '/api/user/psi/stock/report3', data)
  }
  userPsiStockReport4(data) {//统计报表(出库明细)
		return this.getFn(newApj + '/api/user/psi/stock/report4', data)
  }
  userPsiStockReport5(data) {//统计报表(调拨明细)
		return this.getFn(newApj + '/api/user/psi/stock/report5', data)
  }
  userPsiStockReport6(data) {//统计报表(入库汇总)
		return this.getFn(newApj + '/api/user/psi/stock/report6', data)
  }
  userPsiStockReport7(data) {//统计报表(出库汇总)
		return this.getFn(newApj + '/api/user/psi/stock/report7', data)
  }
  userPsiStockList(data) {//库存查询|分析(列表查询)
		return this.getFn(newApj + '/api/user/psi/stock/list', data)
  }
  userPsiStockImport(data) {//库存查询|分析(导入盘库文件)
		return this.postFn(newApj + '/api/user/psi/stock/import', data)
  }
  userPsiPurchaseOrderList(data) {//采购订单(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/order/list', data)
  }
  userPsiPurchaseOrderDetail(data) {//采购订单(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/order/detail', data)
  }
  userPsiPurchaseOrderSave(data) {//采购订单(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/order/save', data)
  }
  userPsiPurchaseOrderDelete(data) {//采购订单(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/order/delete', data)
  }
  userPsiPurchaseOrderAudit(data) {//采购订单(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/order/audit', data)
  }
  userPsiPurchaseOrderAuditEdit(data) {//采购订单(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/order/audit/edit', data)
  }
  userPsiPurchaseHouseInList(data) {//采购入库(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/house/in/list', data)
  }
  userPsiPurchaseHouseInDetail(data) {//采购入库(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/house/in/detail', data)
  }
  userPsiPurchaseHouseInSave(data) {//采购入库(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/save', data)
  }
  userPsiPurchaseHouseInDelete(data) {//采购入库(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/delete', data)
  }
  userPsiPurchaseHouseInAudit(data) {//采购入库(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/audit', data)
  }
  userPsiPurchaseHouseInAuditEdit(data) {//采购入库(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/audit/edit', data)
  }
  userPsiPurchaseHouseOutList(data) {//采购退货(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/house/out/list', data)
  }
  userPsiPurchaseHouseOutDetail(data) {//采购退货(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/house/out/detail', data)
  }
  userPsiPurchaseHouseOutSave(data) {//采购退货(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/save', data)
  }
  userPsiPurchaseHouseOutDelete(data) {//采购退货(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/delete', data)
  }
  userPsiPurchaseHouseOutAudit(data) {//采购退货(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/audit', data)
  }
  userPsiPurchaseHouseOutAuditEdit(data) {//采购退货(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/audit/edit', data)
  }
  userPsiPurchaseCheckList(data) {//应付款审核(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/check/list', data)
  }
  userPsiPurchaseCheckSave(data) {//应付款审核(核销)
		return this.postFn(newApj + '/api/user/psi/purchase/check/save', data)
  }
  userPsiSaleOrderList(data) {//销售订单(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/order/list', data)
  }
  userPsiSaleOrderDetail(data) {//销售订单(详情)
		return this.getFn(newApj + '/api/user/psi/sale/order/detail', data)
  }
  userPsiSaleOrderSave(data) {//销售订单(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/order/save', data)
  }
  userPsiSaleOrderDelete(data) {//销售订单(删除)
		return this.postFn(newApj + '/api/user/psi/sale/order/delete', data)
  }
  userPsiSaleOrderAudit(data) {//销售订单(审核)
		return this.postFn(newApj + '/api/user/psi/sale/order/audit', data)
  }
  userPsiSaleOrderAuditEdit(data) {//销售订单(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/order/audit/edit', data)
  }
  userPsiSaleHouseOutList(data) {//销售出库(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/house/out/list', data)
  }
  userPsiSaleHouseOutDetail(data) {//销售出库(详情)
		return this.getFn(newApj + '/api/user/psi/sale/house/out/detail', data)
  }
  userPsiSaleHouseOutSave(data) {//销售出库(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/save', data)
  }
  userPsiSaleHouseOutDelete(data) {//销售出库(删除)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/delete', data)
  }
  userPsiSaleHouseOutAudit(data) {//销售出库(审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/audit', data)
  }
  userPsiSaleHouseOutAuditEdit(data) {//销售出库(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/audit/edit', data)
  }
  userPsiSaleHouseInList(data) {//销售退货(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/house/in/list', data)
  }
  userPsiSaleHouseInDetail(data) {//销售退货(详情)
		return this.getFn(newApj + '/api/user/psi/sale/house/in/detail', data)
  }
  userPsiSaleHouseInSave(data) {//销售退货(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/save', data)
  }
  userPsiSaleHouseInDelete(data) {//销售退货(删除)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/delete', data)
  }
  userPsiSaleHouseInAudit(data) {//销售退货(审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/audit', data)
  }
  userPsiSaleHouseInAuditEdit(data) {//销售退货(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/audit/edit', data)
  }
  userPsiSaleCheckList(data) {//应收款审核(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/check/list', data)
  }
  userPsiSaleCheckSave(data) {//应收款审核(核销)
		return this.postFn(newApj + '/api/user/psi/sale/check/save', data)
  }
  userPsiHouseInList(data) {//入库管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/in/list', data)
  }
  userPsiHouseInDetail(data) {//入库管理(详情)
		return this.getFn(newApj + '/api/user/psi/house/in/detail', data)
  }
  userPsiHouseInSave(data) {//入库管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/in/save', data)
  }
  userPsiHouseInDelete(data) {//入库管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/in/delete', data)
  }
  userPsiHouseInAudit(data) {//入库管理(审核)
		return this.postFn(newApj + '/api/user/psi/house/in/audit', data)
  }
  userPsiHouseInAuditEdit(data) {//入库管理(反审核)
		return this.postFn(newApj + '/api/user/psi/house/in/audit/edit', data)
  }
  userPsiHouseOutList(data) {//出库管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/out/list', data)
  }
  userPsiHouseOutDetail(data) {//出库管理(详情)
		return this.getFn(newApj + '/api/user/psi/house/out/detail', data)
  }
  userPsiHouseOutSave(data) {//出库管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/out/save', data)
  }
  userPsiHouseOutDelete(data) {//出库管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/out/delete', data)
  }
  userPsiHouseOutAudit(data) {//出库管理(审核)
		return this.postFn(newApj + '/api/user/psi/house/out/audit', data)
  }
  userPsiHouseOutAuditEdit(data) {//出库管理(反审核)
		return this.postFn(newApj + '/api/user/psi/house/out/audit/edit', data)
  }
  userPsiHouseExchangeList(data) {//调拨出库(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/exchange/list', data)
  }
  userPsiHouseExchangeDetail(data) {//调拨出库(详情)
		return this.getFn(newApj + '/api/user/psi/house/exchange/detail', data)
  }
  userPsiHouseExchangeSave(data) {//调拨出库(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/exchange/save', data)
  }
  userPsiHouseExchangeDelete(data) {//调拨出库(删除)
		return this.postFn(newApj + '/api/user/psi/house/exchange/delete', data)
  }
  userPsiHouseExchangeAudit(data) {//调拨出库(审核)
		return this.postFn(newApj + '/api/user/psi/house/exchange/audit', data)
  }
  userPsiHouseExchangeAuditEdit(data) {//调拨出库(反审核)
		return this.postFn(newApj + '/api/user/psi/house/exchange/audit/edit', data)
  }
  userPsiStockCheckList(data) {//盘盈盘亏(列表查询)
		return this.getFn(newApj + '/api/user/psi/stock/check/list', data)
  }
  userPsiStockCheckDetail(data) {//盘盈盘亏(详情)
		return this.getFn(newApj + '/api/user/psi/stock/check/detail', data)
  }
  userPsiStockCheckSave(data) {//盘盈盘亏(新增修改)
		return this.postFn(newApj + '/api/user/psi/stock/check/save', data)
  }
  userPsiStockCheckDelete(data) {//盘盈盘亏(删除)
		return this.postFn(newApj + '/api/user/psi/stock/check/delete', data)
  }
  userPsiStockCheckAudit(data) {//盘盈盘亏(审核)
		return this.postFn(newApj + '/api/user/psi/stock/check/audit', data)
  }
  userPsiStockCheckAuditEdit(data) {//盘盈盘亏(反审核)
		return this.postFn(newApj + '/api/user/psi/stock/check/audit/edit', data)
  }
  userPsiGoodsListAvailable1(data) {//添加商品(列表查询（与场、仓库无关）：采购订单、采购入库单、退货入库单、库存盘盈单、库存盘亏单)
		return this.getFn(newApj + '/api/user/psi/goods/list/available1', data)
  }
  userPsiGoodsListAvailable2(data) {//添加商品(列表查询（与场、仓库有关））：采购退货单、销售单、调拨单)
		return this.getFn(newApj + '/api/user/psi/goods/list/available2', data)
  }
  userPsiGoodsListImport1(data) {//添加商品(导入文件（与场、仓库无关））：采购订单、采购入库单、退货入库单、库存盘盈单、库存盘亏单)
		return this.postFn(newApj + '/api/user/psi/goods/list/import1', data)
  }
  userPsiGoodsListImport2(data) {//添加商品(导入文件（与场、仓库有关））：采购退货单、销售单、调拨单)
		return this.postFn(newApj + '/api/user/psi/goods/list/import2', data)
  }
  userBreedPlanListPen(data) {//添加圈列表(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/list/pen', data)
  }
  userBreedPlanList(data) {//列表查询(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/list', data)
  }
  userBreedPlanDetail(data) {//详情(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/detail', data)
  }
  userBreedPlanSave(data) {//新增修改(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/save', data)
  }
  userBreedPlanDelete(data) {//删除(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/delete', data)
  }
  userBreedPlanAudit(data) {//审核(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/audit', data)
  }
  userStatisticsLaunch(data) {//列表查询(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch', data)
  }
  userStatisticsLaunchDetail(data) {//查看详情(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch/detail', data)
  }
  userStatisticsLaunchDetailPen(data) {//查看详情-出栏日期(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch/detail/pen', data)
  }
  userStatisticsLambing(data) {//列表查询(产羔计划)
		return this.getFn(newApj + '/api/user/statistics/lambing', data)
  }
  userBreedTaskListPenByTaskId (data) {//圈列表-通过任务id查询
		return this.getFn(newApj + '/api/user/breed/task/list/pen/by/task/id', data)
	}
	userBreedTaskListPenByTaskType (data) {//圈列表-通过任务类别查询
		return this.getFn(newApj + '/api/user/breed/task/list/pen/by/task/type', data)
	}
	userBreedTaskListPenAll (data) {//圈列表-非以上10个类别的
		return this.getFn(newApj + '/api/user/breed/task/list/pen/all', data)
	}
  userBreedStandardListAvailable(data) {//下拉列表(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/list/available', data)
  }
  userBreedStandardList(data) {//列表查询(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/list', data)
  }
  userBreedStandardDetail(data) {//详情(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/detail', data)
  }
  userBreedStandardSave(data) {//新增修改(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/save', data)
  }
  userBreedStandardDelete(data) {//删除(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/delete', data)
  }
  userBreedStandardAudit(data) {//审核(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/audit', data)
  }
  userBreedStandardCancel(data) {//作废(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/cancel', data)
  }
  userBreedTaskCategoryTreeAvailable(data) {//可用树结构(下拉选择使用)(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree/available', data)
  }
  userBreedTaskCategoryTreeSecondAvailable(data) {//获取二级分类(下拉选择使用)(下拉选择使用)(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree/second/available', data)
  }
  userBreedTaskCategoryTree(data) {//树结构(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree', data)
  }
  userBreedTaskCategoryFirstSave(data) {//一级新增修改(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/first/save', data)
  }
  userBreedTaskCategorySecondSave(data) {//二级新增修改(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/second/save', data)
  }
  userBreedTaskCategoryDelete(data) {//删除(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/delete', data)
  }
  userWorkflowSetList(data) {//列表查询(审批设置)
		return this.getFn(newApj + '/api/user/workflow/set/list', data)
  }
  userWorkflowSetSave(data) {//新增修改(审批设置)
		return this.postFn(newApj + '/api/user/workflow/set/save', data)
  }
  userWorkflowSetDelete(data) {//删除(审批设置)
		return this.postFn(newApj + '/api/user/workflow/set/delete', data)
  }
  userBreedTaskList(data) {//列表查询(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/list', data)
  }
  userBreedTaskCount(data) {//数量统计(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/count', data)
  }
  userBreedTaskDetail(data) {//详情(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/detail', data)
  }
  userBreedTaskSave(data) {//新增修改(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/save', data)
  }
  userBreedTaskDelete(data) {//删除(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/delete', data)
  }
  userBreedTaskStart(data) {//响应(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/start', data)
  }
  userBreedTaskFocus(data) {//关注和取消关注(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/focus', data)
  }
  userBreedTaskHandle(data) {//处理(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/handle', data)
  }
  userBreedTaskAssist(data) {//协作(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/assist', data)
  }
  userBreedTaskEvaluate(data) {//评价(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/evaluate', data)
  }
  userBreedParamList(data) {//列表查询(养殖参数)
		return this.getFn(newApj + '/api/user/breed/param/list', data)
  }
  userBreedParamSave(data) {//新增修改(养殖参数)
		return this.postFn(newApj + '/api/user/breed/param/save', data)
  }
  userBreedParamDelete(data) {//删除(养殖参数)
		return this.postFn(newApj + '/api/user/breed/param/delete', data)
  }
  userWorkflowList(data) {//列表查询(审批管理)
		return this.getFn(newApj + '/api/user/workflow/list', data)
  }
  userWorkflowCount(data) {//数量统计(审批管理)
		return this.getFn(newApj + '/api/user/workflow/count', data)
  }
  userWorkflowLogList(data) {//流程日志(审批管理)
		return this.getFn(newApj + '/api/user/workflow/log/list', data)
  }
  userDeviceCategoryTree(data) {//产品分类(物联网设备)
		return this.getFn(newApj + '/api/user/device/category/tree', data)
  }
  userDeviceProductList(data) {//产品分类(物联网设备)
		return this.getFn(newApj + '/api/user/device/product/list', data)
  }
  userDeviceInstanceList(data) {//物联设备列表(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/list', data)
  }
  userDeviceInstanceDetail(data) {//物联设备详情(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/detail', data)
  }
  userDeviceInstanceTagsSave(data) {//编辑设备位置(物联网设备)
		return this.postFn(newApj + '/api/user/device/instance/tags/save', data)
  }
  userDeviceInstancePropertiesLatest(data) {//获取设备最新属性值(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/properties/latest', data)
  }
  userDeviceInstancePropertyQuery(data) {//获取设备历史属性值(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/property/query', data)
  }
  userDeviceInstanceTreeCategory(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/tree/category', data)
  }
  userDeviceInstanceTreePosition(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/tree/position', data)
  }
  userDeviceInstanceCount(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/count', data)
  }

	postFn (url,data) {
    return Vue.http.post(url, data,{
      headers: {
        "Authorization": state.token,
      },
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      _this.$message.error(data.body.msg);
    }
    return data
    }).catch((err) => {})
  }
  getFn (url,data) {
    return Vue.http.get(url, {
      params: data,
      headers: { "Authorization": state.token }
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      if(data.body.code !== 401){
        _this.$message.error(data.body.msg);
      }
    }
    return data
    }).catch((err) => {})
  }
  uploadFn (url,data) {
    return Vue.http.post(url, data,{
      headers: {
        "Content-Type": 'multipart/form-data',
        "Authorization": state.token,
      },
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      if(data.body.code !== 401){
        _this.$message.error(data.body.msg);
      }
    }
    return data
    }).catch((err) => {})
  }
  
}

export default new BaseModule()



// WEBPACK FOOTER //
// ./src/api/index.js